import { Router } from 'aurelia-router';
import { autoinject, bindable } from 'aurelia-framework';
import { IdentityHelpers } from '@identity/helpers';
import { IEntityPerson, IUserInfo, IProductOption } from '@shared/interfaces/interfaces';
declare const LIVE_URL: string; // The value is supplied by Webpack during the build

@autoinject
export class NavCourses {

  private router: Router;
  private identity: IdentityHelpers;
  private person: IEntityPerson | null = null;
  private user: IUserInfo | null = null;
  private showAcMenu: boolean = false;
  private showMMenu: boolean = false;
  private body: HTMLElement | null = null;
  private clickListener: any;
  private clickListenerEvent: any;
  private isActiveCommunity: boolean = false;
  private liveUrl: string = LIVE_URL;
  private courseOptions: IProductOption[] = [];

  constructor(router: Router, identity: IdentityHelpers) {
    this.router = router;
    this.identity = identity;
    this.isActiveCommunity = this.identity.user.IsActiveCommunity;
  }

  showHideAccountMenu() {
    this.showAcMenu = !this.showAcMenu;
  }

  showAccountMenu() {
    this.showAcMenu = true;
  }

  hideAccountMenu() {
    this.showAcMenu = false;
  }

  showHideMembersMenu() {
    this.showMMenu = !this.showMMenu;
  }

  showMembersMenu() {
    this.showMMenu = true;
  }

  hideMembersMenu() {
    this.showMMenu = false;
  }

  attached() {
    const bodyElements: HTMLCollectionOf<Element> = document.getElementsByTagName('body');
    if (bodyElements.length) {
      this.body = <HTMLElement>bodyElements[0];
      this.clickListener = (event: any) => {
        const element: HTMLElement = event.target;
        const elementClasses = element.classList;
        if (!elementClasses.contains('nav-ac')) {
          this.hideAccountMenu();
        }
      };
      this.clickListenerEvent = this.clickListener.bind(this);
      this.body.addEventListener('click', this.clickListenerEvent);
    }
  }

  public async bind() {
    this.person = this.identity.user.Person;
    this.user = this.identity.user;
    this.courseOptions = this.identity.user.CourseProductOptions;
    return Promise.resolve();
  }

  detached() {
    if (this.clickListenerEvent) {
      window.removeEventListener('click', this.clickListenerEvent);
    }
  }

}
